<template>
    <svg
        id="Capa_1"
        fill="#48B6E7"
        height="18.258"
        style="enable-background: new 0 0 513.323 513.323"
        viewBox="0 0 513.323 513.323"
        width="17.984"
        x="0px"
        xml:space="preserve"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        y="0px"
    >
        <g>
            <g>
                <path
                    d="M256.661,257.323c-135.275,0-245.333,110.059-245.333,245.333c0,5.888,4.779,10.667,10.667,10.667h469.333
			c5.888,0,10.667-4.779,10.667-10.667C501.995,367.381,391.936,257.323,256.661,257.323z"
                />
            </g>
        </g>
        <g>
            <g>
                <circle cx="256.661" cy="117.333" r="117.333" />
            </g>
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
    </svg>
</template>
<script>
export default {
    name: "UserName",
};
</script>
